var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.854065,
    y: 1.15625,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.854065,
    y: 1.15625,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_55234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2345 27.8192C32.4878 27.8192 30.3019 28.1347 29.5869 28.2458C26.6271 25.0446 25.785 23.225 25.5956 22.7398C25.8523 22.0567 26.7454 19.4618 26.8723 16.129C26.9349 14.4604 26.5946 13.2136 25.8605 12.4232C25.1277 11.6341 24.2407 11.5728 23.9864 11.5728C23.0946 11.5728 21.5985 12.0398 21.5985 15.1677C21.5985 17.8817 22.8202 20.7615 23.1579 21.5055C21.3786 26.8713 19.4684 30.5445 19.0627 31.2999C11.9132 34.0879 11.3541 36.7836 11.3541 37.5476C11.3541 38.9205 12.2981 39.7402 13.8794 39.7402C17.7213 39.7402 21.2272 33.0597 21.8069 31.8997C24.5356 30.7737 28.1877 30.0762 29.1161 29.9097C31.7792 32.5371 34.8591 33.2382 36.138 33.2382C37.1003 33.2382 39.354 33.2382 39.354 30.8384C39.3541 28.6099 36.5962 27.8192 34.2345 27.8192ZM34.0493 29.3947C36.1245 29.3947 36.6729 30.1054 36.6729 30.4812C36.6729 30.7171 36.5865 31.4865 35.4742 31.4865C34.4767 31.4865 32.7546 30.8895 31.0603 29.594C31.7669 29.4978 32.8125 29.3947 34.0493 29.3947ZM23.8775 13.0998C24.0667 13.0998 24.1913 13.1628 24.2939 13.3103C24.8908 14.1681 24.4096 16.9708 23.8238 19.164C23.2584 17.2834 22.8341 14.3978 23.4311 13.3826C23.5478 13.1845 23.6812 13.0998 23.8775 13.0998ZM22.8697 29.8874C23.621 28.3154 24.463 26.0244 24.9217 24.7287C25.8395 26.3198 27.0741 27.7971 27.7881 28.5981C25.565 29.0835 23.883 29.5685 22.8697 29.8874ZM12.8465 37.7573C12.797 37.6965 12.7897 37.5684 12.827 37.4145C12.9052 37.092 13.5029 35.4935 17.8264 33.4905C17.2073 34.5004 16.2395 35.9435 15.1763 37.0216C14.4279 37.7471 13.8452 38.1151 13.4442 38.1151C13.3008 38.1151 13.1032 38.0745 12.8465 37.7573Z",
    fill: "#CC0707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_55234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 29,
    fill: "white",
    transform: "translate(11.3541 11.1562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfCircle);
export default __webpack_public_path__ + "static/media/PdfCircle.cbd7f804e92d38913f8b85376f97fee6.svg";
export { ForwardRef as ReactComponent };